import { Component, HostListener } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { MenuListPage } from "../../menu/menu-list/menu-list";
import { IngredientListPage } from "../../ingredients/ingredient-list/ingredient-list";
import { ProductListPage } from "../../products/product-list/product-list";
import { ReservationLoaderPage } from "../../reservation/reservation-loader/reservation-loader";
import { StockListPage } from "../../stock/stock-list/stock-list";
import { IncomeExpensesListPage } from "../../income-expenses/income-expenses-list/income-expenses-list";
import { Globals } from "../../../globals";
import { ConfigurationImagesPage } from '../../configuration/configuration-images/configuration-images';
import { IngredientsServices } from '../../ingredients/services';
import { ProvidersServices } from '../../providers/services';
import { ProductsServices } from '../../products/services';
import { DishServices } from '../../dish/services';
import { HomePage } from '../../home/home';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoginPage } from '../../auth/login/login';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationServices } from '../../configuration/services';
import { PopupNewAppsPage } from '../popups/popup-new-apps/popup-new-apps';
import { AnalyticsRealtimePage } from '../../analytics/analytics-realtime/analytics-realtime';
import { ConfigurationCloseCashViewPage } from '../../configuration/configuration-close-cash/configuration-close-cash-view/configuration-close-cash-view';
import { AnalyticsPage } from '../../analytics/analytics';
import { TutorialPedidosPage } from '../../help/tutorials/tutorial-pedidos/tutorial-pedidos';
import { TutorialInformesPage } from '../../help/tutorials/tutorial-informes/tutorial-informes';
import { AddonsRealTimePage } from '../../addons/addons-real-time/addons-real-time';
import { TutorialMenusCombosPage } from '../../help/tutorials/tutorial-menus-combos/tutorial-menus-combos';
import { CartasMenusListPage } from '../../cartas-menus/cartas-menus-list/cartas-menus-list';
import { ArticlesListPage } from '../../articles/articles-list/articles-list';
import { OdsViewPage } from '../../ods/ods-view/ods-view';
import { ConfigurationPage } from '../../configuration/configuration';
import { TpvPanelPage } from '../../tpv/tpv-panel/tpv-panel';


/**
 * Generated class for the SideMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'partial-side-menu',
  templateUrl: 'side-menu.html',
})
export class SideMenuPage {

  dish_uid: string = 'aFFFneVkDGiPJvdvWpwJ';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public ingredientsServices: IngredientsServices,
    public providersServices: ProvidersServices,
    public productsServices: ProductsServices,
    public dishServices: DishServices,
    private toastCtrl: ToastController,
    public afAuth: AngularFireAuth,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    public configurationServices: ConfigurationServices) {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    var platform_width = window.innerWidth;
    var side_menu = document.getElementById('side_menu');

    if (platform_width < 600) {
      this.globals.platform_width = 'mobile';
      //
      if (side_menu != null) {
        side_menu.style.display = 'none';
      }
    } else if (platform_width >= 600 && platform_width < 1025) {
      this.globals.platform_width = 'tablet';
      //
      if (side_menu != null) {
        side_menu.style.display = 'none';
      }
    } else if (platform_width >= 1025) {
      this.globals.platform_width = 'desktop';
      //
      if (side_menu != null) {
        side_menu.style.display = 'none';
      }
    }
  }

  openHome() {
    this.globals.side_menu_active = 'dashboard';
    this.resetQuickCreates();
    this.navCtrl.setRoot(HomePage);
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  public openAddons() {
    //link a wordpress
    this.globals.openLandingPricing();
    this.globals.open_side_menu = false;
  }


  public openDish() {
    this.globals.side_menu_active = 'dish';
    this.resetQuickCreates();
    this.navCtrl.setRoot(ArticlesListPage);
    this.globals.side_menu_active_analytics = false;
    this.globals.tourLaunchStep(1);
    this.globals.open_side_menu = false;
  }

  public openMenu() {
    this.globals.side_menu_active = 'menu';
    this.resetQuickCreates();
    this.navCtrl.setRoot(MenuListPage);
    if (this.globals.restaurant.license == 'free') {
      this.navCtrl.push(TutorialMenusCombosPage);
    }
    this.globals.side_menu_active_analytics = false;
    this.globals.tourLaunchStep(1);
    this.globals.open_side_menu = false;
  }

  public openIngredient() {
    this.globals.side_menu_active = 'ingredient';
    this.resetQuickCreates();
    this.navCtrl.setRoot(IngredientListPage);
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  public openProduct() {
    this.globals.side_menu_active = 'product';
    this.resetQuickCreates();
    this.navCtrl.setRoot(ProductListPage);
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }


  public openReservation() {
    this.globals.side_menu_active = 'reservation';
    this.resetQuickCreates();
    this.navCtrl.setRoot(ReservationLoaderPage);
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  public openAnalyticsMenu() {
    if (this.globals.side_menu_active != 'realtime' && this.globals.side_menu_active != 'analytics' && this.globals.side_menu_active != 'close_cash') {
      this.globals.side_menu_active_analytics = !this.globals.side_menu_active_analytics;
    }
    //Tutorial Informes
    if (this.globals.restaurant.license == 'free' && this.globals.side_menu_active_analytics) {
      this.navCtrl.push(TutorialInformesPage);
    }
  }

  public openAnalyticsRealtime() {
    if (this.globals.checkLimitsByLicense('analytics', 'analytics')) {
      this.globals.side_menu_active = 'realtime';
      this.resetQuickCreates();
      this.navCtrl.setRoot(AnalyticsRealtimePage);
    } else {
      this.navCtrl.push(AddonsRealTimePage);
    }
    this.globals.open_side_menu = false;
  }

  public openCloseCash() {
    this.globals.side_menu_active = 'close_cash';
    this.resetQuickCreates();
    this.navCtrl.setRoot(ConfigurationCloseCashViewPage);
    this.globals.open_side_menu = false;
  }

  public openAnalytics() {
    this.globals.side_menu_active = 'informes';
    this.resetQuickCreates();
    this.navCtrl.setRoot(AnalyticsPage);
    this.globals.open_side_menu = false;
  }

  public openTPV() {
    this.globals.side_menu_active = 'tpv';
    this.navCtrl.setRoot(TpvPanelPage, {
      origin: 'tpv'
    });
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  public openStock() {
    this.globals.side_menu_active = 'stock';
    this.resetQuickCreates();
    this.navCtrl.setRoot(StockListPage);
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  public openIncomeExpenses() {
    this.globals.side_menu_active = 'inexp';
    this.resetQuickCreates();
    this.navCtrl.setRoot(IncomeExpensesListPage);
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  public openKitchen() {
    this.globals.side_menu_active = 'kitchen';
    this.navCtrl.setRoot(TpvPanelPage, {
      origin: 'kds'
    });
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  public uploadImage() {
    this.globals.side_menu_config_active = 'images';
    this.resetQuickCreates();
    this.navCtrl.setRoot(ConfigurationImagesPage);
    this.globals.open_side_menu = false;
  }

  public resetQuickCreates() {
    this.ingredientsServices.quick_create = false;
    this.ingredientsServices.quick_create_dish = false;
    this.ingredientsServices.quick_create_type = false;
    this.providersServices.quick_create = false;
    this.productsServices.quick_create = false;
    this.productsServices.quick_create_type = false;
    this.dishServices.quick_create = false;
    this.dishServices.quick_create_type = false;
  }

  openOrders() {
    this.globals.side_menu_active = 'order';
    this.navCtrl.setRoot(TpvPanelPage, {
      origin: 'orders'
    });
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  openSales() {
    this.globals.side_menu_active = 'sales';
    this.resetQuickCreates();
    this.navCtrl.setRoot(TpvPanelPage, {
      origin: 'tpv'
    });
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  openCarta() {
    this.globals.side_menu_active = 'carta';
    this.resetQuickCreates();
    this.navCtrl.setRoot(CartasMenusListPage);
    this.globals.side_menu_active_analytics = false;
    this.globals.open_side_menu = false;
  }

  logout() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-cerrar-sesion'),
      message: this.translate.instant('instant-seguro-quieres-cerrar-sesion'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.open_side_menu = false;
            this.delNotTokenAndLogout();
          }
        }
      ]
    });
    alert.present();
  }

  async delNotTokenAndLogout() {
    //funcion que borra token
    await this.configurationServices.deleteToken(this.globals.token_user_uid, this.globals.token_current_user);
    //hacemos logout de afAuth
    this.afAuth.auth.signOut()
      .then(authData => {
        // toast message
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-cerrado-sesion'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
        if (this.globals.user_type != 'principal' && this.globals.user_type != 'teacher') {
          this.globals.GAtrackView('Logout', 'Logout ', this.globals.restaurant.email, 'Logout', 'Logout', 'Logout', '');
        }

        this.navCtrl.setRoot(LoginPage);
        window.location.reload();
      }, error => {
        //var errorMessage: string = error.message;
      });
  }

  openOds() {
    //Tutorial Pedidos
    if (this.globals.checkLimitsByLicense('sites', 'sites')) {
      this.globals.side_menu_active = 'web';
      this.resetQuickCreates();
      this.navCtrl.setRoot(OdsViewPage);
      this.globals.side_menu_active_analytics = false;
    } else {
      this.globals.side_menu_active = 'web';
      this.resetQuickCreates();
      this.globals.side_menu_active_analytics = false;
      this.navCtrl.push(TutorialPedidosPage);
    }
    this.globals.open_side_menu = false;
  }

  openPrinterApp() {
    this.globals.side_menu_active = 'printer';
    this.navCtrl.setRoot(PopupNewAppsPage, { app: 'print' });
    this.globals.open_side_menu = false;
  }

  openMenuAll() {
    //Menu
    const menu = document.getElementsByClassName('menu_tablet');
    for (let i = 0; i < menu.length; i++) {
      const slide = menu[i] as HTMLElement;
      slide.style.width = "";
    }

    //Boto obrir
    const open = document.getElementsByClassName('open_menu_all');
    for (let i = 0; i < open.length; i++) {
      const slide = open[i] as HTMLElement;
      slide.style.display = 'none';
    }
    //Boto tancar
    const close = document.getElementsByClassName('close_menu_all');
    for (let i = 0; i < close.length; i++) {
      const slide = close[i] as HTMLElement;
      slide.style.display = 'block';
    }

    //Textos dels icones
    const text = document.getElementsByClassName('side-menu-text');
    for (let i = 0; i < text.length; i++) {
      const slide = text[i] as HTMLElement;
      slide.style.display = "contents";
    }
  }

  closeMenuAll() {
    //Menu
    const menu = document.getElementsByClassName('menu_tablet');
    for (let i = 0; i < menu.length; i++) {
      const slide = menu[i] as HTMLElement;
      slide.style.width = "50px";
    }

    //Boto obrir
    const open = document.getElementsByClassName('open_menu_all');
    for (let i = 0; i < open.length; i++) {
      const slide = open[i] as HTMLElement;
      slide.style.display = 'block';
    }
    //Boto tancar
    const close = document.getElementsByClassName('close_menu_all');
    for (let i = 0; i < close.length; i++) {
      const slide = close[i] as HTMLElement;
      slide.style.display = 'none';
    }

    //Textos dels icones
    const text = document.getElementsByClassName('side-menu-text');
    for (let i = 0; i < text.length; i++) {
      const slide = text[i] as HTMLElement;
      slide.style.display = "none";
    }
  }

  openConfig() {
    this.navCtrl.setRoot(ConfigurationPage);
    this.globals.open_side_menu = false;
    this.globals.side_menu_active = 'config';
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/side-menu/side-menu.ts